import { render, staticRenderFns } from "./AboutUS.vue?vue&type=template&id=074e5248&scoped=true&"
import script from "./AboutUS.vue?vue&type=script&lang=js&"
export * from "./AboutUS.vue?vue&type=script&lang=js&"
import style0 from "./AboutUS.vue?vue&type=style&index=0&id=074e5248&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074e5248",
  null
  
)

export default component.exports